module.exports = __webpack_public_path__ + "static/images/solution.94fdcf7f25119c1599f50e3883cd5768.jpg";